import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "81",
  viewBox: "0 0 56 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M55.502 37.2504L-0.373702 69.5103L-0.373699 4.99061L55.502 37.2504Z",
      fill: "#F9D523"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.5801 60.8589L55.5031 37.2495L55.5031 80.5698L14.5801 60.8589Z",
      fill: "#E8A91C"
    }, null, -1)
  ])))
}
export default { render: render }